import { render, staticRenderFns } from "./ResetPassword.vue?vue&type=template&id=5c62c5a5&scoped=true&"
import script from "./ResetPassword.vue?vue&type=script&lang=js&"
export * from "./ResetPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c62c5a5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c62c5a5')) {
      api.createRecord('5c62c5a5', component.options)
    } else {
      api.reload('5c62c5a5', component.options)
    }
    module.hot.accept("./ResetPassword.vue?vue&type=template&id=5c62c5a5&scoped=true&", function () {
      api.rerender('5c62c5a5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/Auth/ResetPassword.vue"
export default component.exports